/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_OutputInputs */

const en_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`output:`)
};

const ar_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المخرجات:`)
};

const bn_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আউটপুট:`)
};

const de_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabe:`)
};

const es_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`salida:`)
};

const fr_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`:`)
};

const pt_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saída:`)
};

const zh_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出：`)
};

const tr_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`çıktı:`)
};

const ru_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вывод:`)
};

const pl_svd_output = /** @type {(inputs: Svd_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`:`)
};

/**
* | output |
* | --- |
* | "output:" |
*
* @param {Svd_OutputInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_output = /** @type {((inputs?: Svd_OutputInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_OutputInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_output(inputs)
	if (locale === "bn") return bn_svd_output(inputs)
	if (locale === "de") return de_svd_output(inputs)
	if (locale === "es") return es_svd_output(inputs)
	if (locale === "fr") return fr_svd_output(inputs)
	if (locale === "pt") return pt_svd_output(inputs)
	if (locale === "zh") return zh_svd_output(inputs)
	if (locale === "tr") return tr_svd_output(inputs)
	if (locale === "ru") return ru_svd_output(inputs)
	if (locale === "pl") return pl_svd_output(inputs)
	return en_svd_output(inputs)
});